import { StablecoinDepositInstructionCreate } from '../../models/deposit-instruction.model';

export class InitStablecoinWalletsState {
	static readonly type: string = '[StablecoinWallets] InitStablecoinWalletsState';
}

export class ClearStablecoinWalletsState {
	static readonly type: string = '[StablecoinWallets] ClearStablecoinWalletsState';
}

export class ResetStablecoinWalletsState {
	static readonly type: string = '[StablecoinWallets] ResetStablecoinWalletsState';
}

export class GetStablecoinWallets {
	static readonly type: string = '[StablecoinWallets] GetStablecoinWallets';
	constructor(public refresh?: boolean) {}
}

export class GetStablecoinWalletBalances {
	static readonly type: string = '[StablecoinWallets] GetStablecoinWalletBalances';
	constructor(public accountId: string) {}
}

export class GetStablecoinBalanceHistory {
	static readonly type: string = '[StablecoinWallets] GetStablecoinBalanceHistory';
	constructor(
		public days: number,
		public accountId?: string
	) {}
}

export class GetStablecoinDepositInstructions {
	static readonly type: string = '[StablecoinWallets] GetStablecoinDepositInstructions';
	constructor(public accountId: string) {}
}

export class CreateStablecoinDepositInstructions {
	static readonly type: string = '[StablecoinWallets] CreateStablecoinDepositInstructions';
	constructor(public body: StablecoinDepositInstructionCreate) {}
}
